import { render, staticRenderFns } from "./addDeparyment.vue?vue&type=template&id=0eccbe0c"
import script from "./addDeparyment.vue?vue&type=script&lang=js"
export * from "./addDeparyment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports